<div class="join-link">
  <app-qr-code class="join-link__qr" [value]="url" [size]="qrSize" [label]="url" logo="/assets/img/logo-icon.svg"></app-qr-code>
  <div class="join-link__body">
    <div class="join-link__row">
      <input
        id="input-club-link"
        bv-input
        type="text"
        readonly
        [value]="url"
        (focus)="$any($event.target).select()"
        />
      <button
        id="btn-copy-club-link"
        bv-button variant="ghost" iconOnly
        type="button"
        [attr.aria-label]="'COPY_LINK' | translate"
        (click)="copy()"
        >
        <bv-icon name="content_copy"></bv-icon>
      </button>
      <a
        id="btn-print-club-link"
        bv-button variant="secondary" size="sm"
        [routerLink]="['/join', id, 'print']"
        target="_blank"
        >
        <bv-icon name="print"></bv-icon>
        {{ "PRINT_POSTER" | translate }}
      </a>
    </div>
    <ng-content></ng-content>
  </div>
</div>
